import React, { useEffect, useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import InputMask from 'react-input-mask'
import { makeStyles } from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Delete'
import CheckIcon from '@material-ui/icons/Check'
import { TextField, Grid, Button, Checkbox, Divider } from '@material-ui/core'
import API from '../../../../services/api'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(2),
    maxWidth: 900,
  },
  cabecalho: {
    margin: 0,
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '0.6px',
    color: '#7A7373',
  },
  secao: {
    margin: '4px 0 0',
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '0.6px',
    color: '#7A7373',
  },
  celula: {
    margin: 0,
    fontSize: 14,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  adicionar: {
    background: '#d05d02',
    color: '#fff',
    fontSize: '14px',
    textTransform: 'capitalize',
    fontWeight: 700,
    width: '138px',
    '&:hover': { background: '#A74A00' },
  },
  formControl: {
    margin: theme.spacing(3),
  },
  bottom: {
    margin: theme.spacing(2),
  },
}))

function dateSaveFormat(date) {
  const splitDate = date.split('/')
  return `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`
}

function Feriados() {
  const classes = useStyles()
  const { register, control, handleSubmit } = useForm()
  const [shoppingHollidays, setShoppingHollidays] = useState(false)
  const [repeat, setRepeat] = useState(false)

  const getHollidays = async () => {
    const result = await API.get('store/hollidays/next')
    setShoppingHollidays(result.data.nextHollidays)
  }

  const onSubmit = async (data) => {
    const newholliday = {
      date: dateSaveFormat(data.date),
      description: data.description,
      repeat,
    }
    await API.post('store/hollidays/new', newholliday)
    getHollidays()
  }

  const deleteHolliday = async (id) => {
    await API.delete(`store/holliday/${id}`)
    getHollidays()
  }

  useEffect(() => {
    if (!shoppingHollidays) {
      getHollidays()
    }
  }, [])

  if (!shoppingHollidays) {
    return null
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <h3 className={classes.secao}>PRÓXIMOS FERIADOS</h3>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={3} sm={2}>
          <h3 className={classes.cabecalho}>DATA</h3>
        </Grid>
        <Grid item xs={5} sm={5}>
          <h3 className={classes.cabecalho}>DESCRIÇÃO</h3>
        </Grid>
        <Grid item xs={4} sm={2}>
          <h3 className={classes.cabecalho}>REPETE TODO ANO</h3>
        </Grid>
      </Grid>

      {shoppingHollidays?.map((holliday) => (
        <Grid container spacing={2} key={holliday.id} alignItems="center">
          <Grid item xs={12}>
            <Divider variant="fullWidth" />
          </Grid>
          <Grid item xs={3} sm={2}>
            <p className={classes.celula}>{holliday.dateStr}</p>
          </Grid>
          <Grid item xs={5} sm={5}>
            <p className={classes.celula} title={holliday.description}>
              {holliday.description}
            </p>
          </Grid>
          <Grid item xs={2} sm={2}>
            {holliday.repeat ? <CheckIcon /> : null}
          </Grid>
          <Grid item xs={2} sm={3} container justify="flex-end">
            <DeleteIcon
              style={{ color: '#f33838', cursor: 'pointer' }}
              onClick={() => {
                deleteHolliday(holliday.id)
              }}
            />
          </Grid>
        </Grid>
      ))}

      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <Divider variant="fullWidth" />
          </Grid>
          <Grid item xs={3} sm={2}>
            <Controller
              control={control}
              name="date"
              as={
                <InputMask mask="99/99/9999">
                  {() => (
                    <TextField
                      fullWidth
                      id="date"
                      name="date"
                      inputRef={register}
                      variant="outlined"
                      size="small"
                      placeholder="__/__/____"
                    />
                  )}
                </InputMask>
              }
            />
          </Grid>
          <Grid item xs={5} sm={5}>
            <TextField
              fullWidth
              id="description"
              name="description"
              inputRef={register}
              variant="outlined"
              size="small"
              placeholder=""
            />
          </Grid>
          <Grid item xs={2} sm={2}>
            <Checkbox
              edge="start"
              name="repet"
              onClick={() => {
                setRepeat(!repeat)
              }}
              defaultChecked={repeat}
              tabIndex={-1}
              disableRipple
            />
          </Grid>
          <Grid item xs={2} sm={3} container justify="flex-end">
            <Button
              variant="contained"
              type="submit"
              className={classes.adicionar}
            >
              Adicionar
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  )
}

export default Feriados
